import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const app = firebase.initializeApp({
  apiKey: 'AIzaSyCuuj4WeeoTxkkcwqerg3BWa-w5PWacBhg',
  authDomain: 'shopping-list-79da0.firebaseapp.com',
  databaseURL: 'https://shopping-list-79da0.firebaseio.com',
  projectId: 'shopping-list-79da0',
  storageBucket: '',
  messagingSenderId: '512532142447',
  appId: '1:512532142447:web:a786951eec113fb95eb09a',
})

app.firestore().enablePersistence()
  .catch(error => {
    console.log({ error })
    if (error.code === 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      // ...
    } else if (error.code === 'unimplemented') {
      // The current browser does not support all of the
      // features required to enable persistence
      // ...
    }
  })

export const db = app.firestore()

export const auth = app.auth()